import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { IcUsers24Icon } from '@gem/icons';
import { IconButton, IconViewSizes } from '@gem/ui-kit';

import { useShowMembersButton } from './ShowMembersButton.presenter';
import styles from './ShowMembersButton.styles.m.css';

interface IShowMembersButtonProps {
  className?: string;
}

export const ShowMembersButton: FC<IShowMembersButtonProps> = observer(({ className }) => {
  const presenter = useShowMembersButton();
  const { ongoingCall } = presenter;

  const onClick = (): void => {
    if (!ongoingCall.uiFeatures.isActiveControlParticipantListWeb) {
      return;
    }
    if (ongoingCall.viewState.backgroundPanelShown) {
      ongoingCall.viewState.hideBackgroundPanel();
    }
    if (ongoingCall.viewState.isPermissionsRequestsShown) {
      ongoingCall.viewState.hidePermissionsRequests();
      return;
    }
    ongoingCall.viewState.toggleMembers();
  };

  return (
    <IconButton
      Icon={IcUsers24Icon}
      onClick={onClick}
      size={IconViewSizes.Big}
      theme={ongoingCall.viewState.isMembersShown ? '13' : '12'}
      iconSize={IconViewSizes.Medium}
      className={classNames(styles.button, className)}
      text={presenter.text}
      title={presenter.title}
    />
  );
});
